"use client"

import { env } from "~/env"
import clsx from "clsx"

import type { PropsWithClassName } from "~/@types/generics"
import { useYotpoRefresh } from "~/hooks/useYotpoRefresh"

type YotpoStarsProps = PropsWithClassName<{ productGID?: number | null }>

function YotpoStars({ className, productGID }: YotpoStarsProps) {
  useYotpoRefresh()

  return (
    <div
      className={clsx("yotpo-widget-instance", className)}
      data-yotpo-instance-id={env.NEXT_PUBLIC_STARS_YOTPO_WIGDET_INSTANCE_ID}
      data-yotpo-product-id={productGID}
    ></div>
  )
}

export { YotpoStars }
